import { useState } from "react";

type Draft = { text: string; status: string };
const key = (id: number) => `analects-workbench-question:${id}`;

function read(id: number): Draft {
  try {
    const text = localStorage.getItem(key(id)) ?? "";
    return { text, status: text ? "已恢復本機問題" : "" };
  } catch {
    return { text: "", status: "無法讀取本機草稿；請先保留問題文字。" };
  }
}

/** Per-chapter drafts stay in memory across mode/chapter changes. Saving is explicit. */
export function useQuestionDraft(id: number) {
  const [drafts, setDrafts] = useState<Record<number, Draft>>({});
  const draft = drafts[id] ?? read(id);
  function updateQuestion(text: string) {
    setDrafts(previous => ({ ...previous, [id]: { text, status: "尚未保存" } }));
  }
  function saveQuestion() {
    let status = "問題已保存在本機";
    try { localStorage.setItem(key(id), draft.text); }
    catch { status = "保存失敗；問題仍在此頁，請先複製保留。"; }
    setDrafts(previous => ({ ...previous, [id]: { text: draft.text, status } }));
  }
  return { question: draft.text, draftStatus: draft.status, updateQuestion, saveQuestion };
}
